function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_493",
  "data-name": "Rectangle 493",
  width: 40.779,
  height: 24,
  transform: "translate(0 71)",
  fill: "#2294d2",
  stroke: "#2294d2",
  strokeWidth: 0.75
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_1",
  "data-name": "Mask Group 1",
  transform: "translate(0 -71)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Calendar",
  transform: "translate(8.389 71)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1655",
  "data-name": "Group 1655",
  transform: "translate(5.6 10.4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_871",
  "data-name": "Path 871",
  d: "M266.867,500.867a3.127,3.127,0,0,1-3.2-3.04.378.378,0,0,1,.4-.4.448.448,0,0,1,.4.48,2.326,2.326,0,0,0,2.4,2.24,2.245,2.245,0,1,0,0-4.48h-1.68a.4.4,0,1,1,0-.8h1.68a2.276,2.276,0,0,0,2.4-2.24,2.214,2.214,0,0,0-2.4-2.16,2.276,2.276,0,0,0-2.4,2.24.378.378,0,0,1-.4.4.429.429,0,0,1-.4-.4,3.2,3.2,0,0,1,6.4,0,3.067,3.067,0,0,1-1.6,2.64,2.971,2.971,0,0,1,1.6,2.64A3.105,3.105,0,0,1,266.867,500.867Z",
  transform: "translate(-263.667 -489.667)",
  fill: "#2294d2",
  stroke: "#2294d2",
  strokeWidth: 0.75
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1656",
  "data-name": "Group 1656",
  transform: "translate(14.44 10.367)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_872",
  "data-name": "Path 872",
  d: "M682.643,499.339a.378.378,0,0,1-.4-.4V489.5l-1.68,1.68a.4.4,0,0,1-.56-.56l2.4-2.4c.08-.08.32-.16.4-.08a.44.44,0,0,1,.24.4v10.4A.378.378,0,0,1,682.643,499.339Z",
  transform: "translate(-679.883 -488.106)",
  fill: "#2294d2",
  stroke: "#2294d2",
  strokeWidth: 0.75
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1657",
  "data-name": "Group 1657",
  transform: "translate(0 2.4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_873",
  "data-name": "Path 873",
  d: "M20.56,134.6H3.44A3.4,3.4,0,0,1,0,131.24V116.36A3.4,3.4,0,0,1,3.44,113a.4.4,0,1,1,0,.8A2.6,2.6,0,0,0,.8,116.36v14.88a2.6,2.6,0,0,0,2.64,2.56H20.56a2.6,2.6,0,0,0,2.64-2.56V116.36a2.6,2.6,0,0,0-2.64-2.56.4.4,0,1,1,0-.8A3.4,3.4,0,0,1,24,116.36v14.88A3.4,3.4,0,0,1,20.56,134.6Z",
  transform: "translate(0 -113)",
  fill: "#2294d2",
  stroke: "#2294d2",
  strokeWidth: 0.75
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1658",
  "data-name": "Group 1658",
  transform: "translate(7.2 2.4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_874",
  "data-name": "Path 874",
  d: "M348.2,113.8h-8.8a.4.4,0,0,1,0-.8h8.8a.4.4,0,1,1,0,.8Z",
  transform: "translate(-339 -113)",
  fill: "#2294d2",
  stroke: "#2294d2",
  strokeWidth: 0.75
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1659",
  "data-name": "Group 1659",
  transform: "translate(4.8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_875",
  "data-name": "Path 875",
  d: "M226.4,4.8a.378.378,0,0,1-.4-.4V.4a.4.4,0,1,1,.8,0v4A.378.378,0,0,1,226.4,4.8Z",
  transform: "translate(-226)",
  fill: "#2294d2",
  stroke: "#2294d2",
  strokeWidth: 0.75
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1660",
  "data-name": "Group 1660",
  transform: "translate(18.4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_876",
  "data-name": "Path 876",
  d: "M866.734,4.8a.378.378,0,0,1-.4-.4V.4a.4.4,0,0,1,.8,0v4A.378.378,0,0,1,866.734,4.8Z",
  transform: "translate(-866.333)",
  fill: "#2294d2",
  stroke: "#2294d2",
  strokeWidth: 0.75
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1661",
  "data-name": "Group 1661",
  transform: "translate(0 7.2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_877",
  "data-name": "Path 877",
  d: "M23.6,339.8H.4a.4.4,0,0,1,0-.8H23.6a.4.4,0,0,1,0,.8Z",
  transform: "translate(0 -339)",
  fill: "#2294d2",
  stroke: "#2294d2",
  strokeWidth: 0.75
}))));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40.779,
    height: 24,
    viewBox: "0 0 40.779 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.66ad9472.svg";
export { ForwardRef as ReactComponent };